import { Component, OnInit, OnDestroy, Input, ChangeDetectorRef } from '@angular/core';
import { FormGroup, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

// services
import { NavigationService } from '../../services/navigation.service';

@Component({
    selector: 'owner-count',
    templateUrl: './owner-count.component.html',
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: OwnerCountComponent,
        multi: true
    }],
    styles: []
})

export class OwnerCountComponent implements OnInit, OnDestroy, ControlValueAccessor {
    @Input() form: FormGroup;
    @Input() isEditable: boolean;
    totalOwners: any = 0;
    onChange: any = () => { };
    onTouched: any = () => { };
    private _onDestroy = new Subject();

    constructor(
        public route: ActivatedRoute,
        private navigationService: NavigationService,
        private changeDetector: ChangeDetectorRef,
    ) {}

    ngOnInit() {
        if (!this.isEditable) {
            this.navigationService.disableMultipleReponseButton(true);
        }else {
            const policyOwnerTypesWithSignators = ['Business', 'ExistingTrust', 'TrustToBeEstablished'];
            this.form.valueChanges.pipe(debounceTime(75), distinctUntilChanged(), takeUntil(this._onDestroy)).subscribe(value => {
                this.totalOwners = 0;
                if ('PolicyOwnerInformation' in value) {
                    value.PolicyOwnerInformation.forEach(arrayChild => {
                        if (arrayChild.PolicyOwnerType== null || !policyOwnerTypesWithSignators.includes(arrayChild.PolicyOwnerType)) {
                            this.totalOwners++;
                        } else if (policyOwnerTypesWithSignators.includes(arrayChild.PolicyOwnerType)  && 'SigningOfficerCompound' in arrayChild) {
                            this.totalOwners = this.totalOwners + arrayChild.SigningOfficerCompound.length;
                        }
                    });
                } 
                if (this.totalOwners > 9) {
                    this.navigationService.disableMultipleReponseButton(true);
                } else {
                    this.navigationService.disableMultipleReponseButton(false);
                }
                this.checkSolePolicyOwner(value);
            });
        }
    }

    checkSolePolicyOwner(value){
        if ('PolicyOwnerInsuredNo' in value) {
            if (value['PolicyOwnerInsuredNo'] === 'true' && this.totalOwners<= 9){
                document.getElementById('PolicyOwnerInformation').removeAttribute("disabled");
            }
            if (value['PolicyOwnerInsuredNo'] === 'false'){
                document.getElementById('PolicyOwnerInformation').setAttribute("disabled", "true");
            }
        }
    }

    ngOnDestroy() {
        this.navigationService.disableMultipleReponseButton(false);
        this._onDestroy.next();
    }

    // Control Value Accessor interface
    writeValue(value: string) {
        this.totalOwners = value;
        this.changeDetector.markForCheck();
    }

    // Control Value Accessor interface
    registerOnChange(fn: any) {
        this.onChange = fn;
    }

    // Control Value Accessor interface
    registerOnTouched(fn: any) {
        this.onTouched = fn;
    }
}
